export const ADMIN_CANCEL_WITH_FEES = "ADMIN_CANCEL_WITH_FEES";
export const ADMIN_CANCEL_WITHOUT_FEES = "ADMIN_CANCEL_WITHOUT_FEES";
export const SUGGEST_TIMESLOT = "SUGGEST_TIMESLOT";
export const ADMIN_REOPENING = "ADMIN_REOPENING";
export const RESCHEDULE = "RESCHEDULE";
